/**
 * 车辆档案一览模块
 * 创建时间：2017-02-22
 * 创建人：zhanlz
 * 修改人：masonchen
 * 修改时间：2017-04-18
 */
<template>	
	<div id="carfile-list" class="wrapper wrapper-content fadeInRight animated tabBox">
	   <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">车辆ID</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.vehicleId" maxlength="10">
				</div>
				<label class="col-sm-1 control-label">服务卡号</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim="queryParam.vehicleAccount" maxlength="20">
				</div>
				<label class="col-sm-1 control-label">起始时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.serviceTimeBegin" class="form-control" ref="dateFrom"></datepicker>
					<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">结束时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
					<datepicker v-model="queryParam.serviceTimeEnd" class="form-control" ref="dateTo"></datepicker>
	                <p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">车牌号</label>
				<div class="col-sm-2">
					<vplate-input type="text" class="form-control" v-model.trim="queryParam.plateNumber" maxlength="9"/>
				</div>
				<label class="col-sm-1 control-label">当前位置</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim="queryParam.address" maxlength="20">
				</div>
				<label class="col-sm-1 control-label">车主</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim="queryParam.vehicleOwnerName" maxlength="10">
				</div>
				<label class="col-sm-1 control-label">联系方式</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim="queryParam.phone" maxlength="11">
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">车辆分支</label>
				<div class="col-sm-2">
					<input type="text" id="group_list" class="form-control menuInput" v-model="queryGroup" @focus="showMenu" autocomplete="off" disableautocomplete>
					<div id="menuContentF" class="menuContent" style="display:none; position: absolute;">
						<ul id="carOrgTree" class="ztree ztree-slide" style="margin-top:0; width:250px; height: 300px;"></ul>
					</div>
				</div>
				<label class="col-sm-1 control-label">设备编号</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model.trim="queryParam.deviceNum" maxlength="20">
				</div>
				<div class="col-sm-6 text-right">
					<button v-if="permission.indexOf('fileCarList_download') == -1" class="btn btn-primary" @click="openDownload" :disabled="!validDates">下载</button>
					<button v-if="permission.indexOf('fileCarList_upload') == -1" class="btn btn-primary" @click="openFileUpload" :disabled="!validDates">上传</button>
					<button  class="btn btn-primary" @click="removeVehicle">删除</button>
					<button v-if="permission.indexOf('fileCarList_reset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
					<button v-if="permission.indexOf('fileCarList_select') == -1" class="btn btn-primary" @click="searchInfo" :disabled="!validDates">查询</button>
					<button v-if="permission.indexOf('fileCarList_changeToTest') == -1" class="btn btn-danger" @click="turnformalCar(1)" :disabled="!validDates">正式车降级成测试车</button>
					<button v-if="permission.indexOf('fileCarList_changeToFormal') == -1" class="btn btn-primary" @click="turnformalCar(2)" :disabled="!validDates">测试车升级成正式车</button>
				</div>
			</div>
			<div class="hr-line-dashed"></div>
		</div>
		
		<!--表格开始-->
		<div class="table-responsive">
			<table class="table table-striped table-bordered table-hover">
				<thead>
					<tr role="row">
						<th></th>
						<th>车辆ID</th>
						<th>设备编号</th>
						<th>服务卡号</th>
						<th>所属分支</th>
						<th>服务结束日</th>
						<th>车型车系</th>
						<th>车牌号</th>
						<th>车牌登记日</th>
						<th>当前位置</th>
						<th>车主</th>
						<th>联系方式</th>
						<th>车辆类型</th>
						<th>设备保单号</th>
						<th></th>
					</tr>
				</thead>
				<transition-group name="list-complete" tag="tbody">
					<tr v-for="(fileInfo,index) in fileInfoList" v-bind:key="index + 'filecar'" class="list-complete-item">
						<td class="text-center"><input style="margin-top:0px;" type="checkbox" v-model="vehicleSelectArr" :value="fileInfo.vehicleId"></td>
						<td>VE{{fileInfo.vehicleId}}</td>
						<td>{{fileInfo.deviceNum}}</td>
						<td>{{fileInfo.vehicleAccount}}</td>
						<td>{{fileInfo.groupName}}</td>
						<td>{{fileInfo.serviceEndTime}}</td>
						<td>{{fileInfo.vehicleTypeSerie}}</td>
						<td>{{fileInfo.plateNumber}}</td>
						<td>{{fileInfo.startSaleTime}}</td>
						<td>{{fileInfo.address}}</td>
						<td>{{fileInfo.vehicleOwnerName}}</td>
						<td>{{fileInfo.phone}}</td>
						<td>{{fileInfo.isTestCar==0?'正式车':'测试车'}}</td>
						<td>{{fileInfo.insuranceNo}}</td>
						<td class="text-center">
							<a v-if="permission.indexOf('fileCarList_detail') == -1" @click="addTab(fileInfo.plateNumber,fileInfo.vehicleId)">详情</a>
						</td>
					</tr>
				</transition-group>
			</table>
		</div>
		
		<pagination v-if="fileInfoList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
		</div>
		
		<!--文件上传-->
		<sub-page 
			:show="toShow" 
			:bigTitleMsg="bigTitle" 
			:scroll="scrollTop" 
			v-on:cancel="handleSubPage">
			<div slot="bodycontent">
				<file-upload
					v-if="toShow"
					v-on:cancel="handleSubPage"
					>
				</file-upload>
			</div>
		</sub-page>
		<!--文件下载-->
		<sub-page 
			:show="toDownShow" 
			:bigTitleMsg="bigTitle" 
			:scroll="scrollTop" 
			v-on:cancel="handleDownSubPage">
			<div slot="bodycontent">
				<file-download
					v-if="toDownShow"
					v-on:cancel="handleDownSubPage"
					>
				</file-download>
			</div>
		</sub-page>
		
		<main-modal ref="modalAdmin" size="normal" title="正式车降级为测试车" @close="closeAdmin">
			<div class="row">
				<div class="col-sm-12 text-center">
					<div>
						<label class="col-sm-1 control-label t_center red">理由</label>
					    <textarea rows="6" class="col-sm-11" v-model="remarks" maxlength="250"></textarea>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button @click="confirform()" class="btn btn-primary text-center">确定</button>
			</div>
		</main-modal>
		
		
	   	<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		
		<!--   弹出框子组件2        -->
		<tab-modal ref="modal2" size="small" title="提示" :scroll='scrollTop' v-on:cancel="closeModal('modal2')">
			确定删除所选车辆？
			<div slot="footer">
		            <button @click="closeModal('modal2')" class="btn btn-primary">取消</button>
		            <button @click="removeItem()" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		<!--   弹出变为正式车子组件        -->
		<tab-modal ref="modalformalCar" size="small" title="提示" :scroll='scrollTop' v-on:cancel="closeModal('modalformalCar')">
			{{messageStr}}
			<div slot="footer">
		            <button @click="closeModal('modalformalCar')" class="btn btn-primary">取消</button>
		            <button @click="confirformalCar()" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</template>

<script>
    import MainModal from 'components/common/MainModal'
    import Pagination from 'components/common/Pagination'
    import PageFileCarDetail from 'components/pages/didicarfile/PageFileCarDetail'
    import TabModal from 'components/common/TabModal'
	import Datepicker from 'components/common/datepicker/Datepicker'
    import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
    import { queryTree } from 'util/util'
    import FileUpload from 'components/common/FileUpload'
    import FileDownload from 'components/common/FileDownload'
    import SubPage from 'components/common/SubPage'
    import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
	import 'assets/plugins/ztree/js/jquery.ztree.core.js'
	import 'assets/plugins/ztree/js/jquery.ztree.excheck.js'
	import 'assets/plugins/ztree/js/jquery.ztree.exedit.js'
	import classlist from 'util/classlist'
	export default {
		name: 'PageFileCarList',
		components: {
			Pagination,
			PageFileCarDetail,
			TabModal,
			Datepicker,
			SubPage,
			FileUpload,
			FileDownload,
			MainModal
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["fileCarList"]?this.$store.state.permission.permission["fileCarList"]:[],
				loadingstatus:false,
				groupList:[],											// 分组信息
				fileInfoList:[],										// 查询结果
				contaArray:[],                                          //车辆转换数组集合
				vehicleSelectArr:[],
				pageInfo:{},											//分页所需信息
				pageNo: 1, 												//分页返回的当前页数
				queryGroup:'',											//选中的groupid
				queryParam:{											// 查询参数
					vehicleId: "",										// 车辆ID
					deviceNum:'',										// 设备编号
					vehicleAccount: "",									// 服务卡号
					serviceTimeBegin: "",								// 起始时间
					serviceTimeEnd: "",									// 结束时间
					plateNumber: "",									// 车牌号
					address: "",										// 当前位置
					vehicleOwnerName: "",								// 车主
					phone: "",											// 联系方式
					groupId:" ",		    // 车辆分组 3234783
					page_index: 1,										// 当前第几页
					sort_desc: "",										// 倒序参数
					sort_asc: ""										// 正序参数
				},
				groupQueryParam:{
					exGroupId:"",
					showTreeType:"0"
				},
				messageStr: "",					// 弹出框内容
				scrollTop: '0',
				toShow: false, //默认不显示subpage页（新建、编辑和详情组件弹框）
				toDownShow: false, //下载框显示
				bigTitle: '', //详情弹框标题
				treeObj:{},
				normalTest:'',        //正式测式
				remarks:'',           //理由
				//z-tree相关
				setting:{
					data: {
		                simpleData: {
		                    enable: true,
		                    idKey: "id",
							pIdKey: "pId"
		                }
		           },
		           view: {
				        dblClickExpand: false,
				        selectedMulti: false,
				        autoCancelSelected: true
				    },
				    callback: {
				        onClick: this.onClick
				    }
				},
				setting2:{
					data: {
		                simpleData: {
		                    enable: false,
		                }
		           },
		           view: {
				        dblClickExpand: false,
				        selectedMulti: false,
				        autoCancelSelected: true
				    },
				    callback: {
				        onClick: this.onClick
				    }
				}
			};
		},
		beforeMount(){
			this.getTableInfo();
			this.getGroups();
		},
		mounted(){
			this.treeInit()
		},
		computed: {
			//	起止时间是否合法
			validDates: function(){
				if(this.queryParam.serviceTimeBegin && this.queryParam.serviceTimeEnd && this.queryParam.serviceTimeBegin > this.queryParam.serviceTimeEnd){
					return false;
				} else {
					return true;
				}
			}
		},
		watch:{
			queryGroup(val){
				if(val){
					let nodeList = queryTree(this.treeObj, val);
					//将找到的nodelist节点更新至Ztree内
					for( var i=0, l=nodeList.length; i<l; i++) {
						nodeList[i].open = false;
					}
        			$.fn.zTree.init($("#carOrgTree"), this.setting2, nodeList);
				}else{
					$.fn.zTree.init($("#carOrgTree"), this.setting, this.groupList);
				}
			}
		},
		methods:{
			//显示、隐藏下拉树
			showMenu(){
				$(".menuContent").slideDown("fast");
				$("body").bind("mousedown", this.onBodyDown);
			},
			onBodyDown(event){
				var self = this;
				if (!(event.target.id == "group_list" || event.target.id == "menuContentF" || $(event.target).parents(".menuContent").length>0)) {
					this.hideMenu();
				}
			},
			hideMenu() {
				$(".menuContent").fadeOut("fast");
				$("body").unbind("mousedown", this.onBodyDown);
			},
			//z-tree 相关
			treeInit(){//初始化z-tree树
				$.fn.zTree.init($("#carOrgTree"), this.setting, this.groupList);
				this.$nextTick(() => {
					this.treeObj = $.fn.zTree.getZTreeObj("carOrgTree").getNodes();
				})
			},
			onClick(e,treeId,treeNode){//点击树节点
				this.queryParam.groupId = treeNode.id
				this.queryGroup = treeNode.name
			},
			//查询方法
			searchInfo(){
				if(this.queryGroup==''){
					this.queryParam.groupId = ''
				}
				this.queryParam.page_index = 1;
				this.getTableInfo();
			},
			getTableInfo:function(){
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/', {params: this.queryParam})
				.then( res => {
					if(res.body.success){
						const resInfo = res.body.data;								
						const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
						this.pageInfo = {
							pageNum: pageNum,
							pages: pages,
							total: total,
							isFirstPage: isFirstPage,
							isLastPage: isLastPage
						}
						this.fileInfoList = resInfo.list;
						for(var i = 0; i < this.fileInfoList.length; i++) {
							if(!(JSON.stringify(this.contaArray).indexOf(this.fileInfoList[i].vehicleAccount)!=-1)){
								this.contaArray.push(this.fileInfoList[i])
							}
						}
						this.loadingstatus = false;
					} else {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}
				}, res => {
					this.openModalMsg(res.body.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})
			},
			getGroups:function(){
				this.$http.get(process.env.API_ROOT +'/monitor/tree/groups/', {params:this.groupQueryParam})
				.then( res => {
					if(res.body.success){
						let resInfo = res.body.data;
						this.groupList = resInfo;
					//	this.queryGroup = resInfo[0].name
						this.groupList.map(item => {
							item.open = true;
							return item;
						})
						this.treeInit()
					} else {
						this.openModalMsg(res.body.message);
					}
				}, res => {
					this.openModalMsg(res.body.message);
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
				})
			},
			//从分页组件获取页码参数
			getPageNo(pageNo){
				this.pageNo = pageNo;
				this.queryParam.page_index = pageNo;
				this.getTableInfo();
			},
			resetQueryParams:function(){
				this.$refs.dateFrom.handleClear();
				this.$refs.dateTo.handleClear();
				this.queryParam = {
					vehicleId: "",										// 车辆ID
					vehicleAccount: "",									// 服务卡号
					serviceTimeBegin: "",								// 起始时间
					serviceTimeEnd: "",									// 结束时间
					plateNumber: "",									// 车牌号
					address: "",										// 当前位置
					vehicleOwnerName: "",								// 车主
					phone: "",											// 联系方式
					groupId: this.$store.state.user.groupid,		    // 车辆分组   3234783
					page_index: 1,										// 当前第几页
					sort_desc: "",										// 倒序参数
					sort_asc: "",										// 正序参数
				}
			//	this.queryGroup = this.groupList[0].name
				this.queryGroup = ''
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#carfile-list',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#carfile-list',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
        	addTab:function(plateNumber,id){
				if(plateNumber){
					const obj = {
						name:plateNumber,
						id:'PageFileCarDetail',
						route:'/indexhome/fileCarDetail' + id,
						No:'file' + id,
						params:{id: id}
					}
					this.$router.push({path:'/indexhome/fileCarDetail' + id,query:{id: id}});
					this.$store.dispatch('addTab',obj);
				}else{
					const obj = {
						name:"VE" + id,
						id:'PageFileCarDetail',
						route:'/indexhome/fileCarDetail' + id,
						No:'file' + id,
						params:{id: id}
					}
					this.$router.push({path:'/indexhome/fileCarDetail' + id,query:{id: id}});
					this.$store.dispatch('addTab',obj);
				}
			},
			handleSubPage(){
				this.toShow = false;
			},
			openFileUpload(){
				this.bigTitle = '文件上传'
				this.toShow = true;
			},
			handleDownSubPage(){
				this.toDownShow = false;
			},
			openDownload(){
				this.bigTitle = '文件下载'
				this.toDownShow = true;
			},
			//关闭变为测试车理由弹框
			closeAdmin(){
				classlist.toggleScroll('open','#carfile-list',this);
		    },
		    //输入理由后确认
		    confirform(){
		    	if(this.remarks ==""){
		    		this.openModalMsg("理由不能为空");
		    		return;
		    	}
		    	this.$refs.modalAdmin.close();
		    	this.remarks = "";
		    	classlist.toggleScroll('open','#carfile-list',this);
		    	this.messageStr = '确定将所选正式车变为测试车?'
		    	this.openModal("modalformalCar");
		    },
			turnformalCar(normalTest){
				if(this.vehicleSelectArr.length==0){
					this.openModalMsg("请选择要变更的车辆");
					return;
				}
				this.normalTest = normalTest
				if(normalTest == 1){
					for(var i = 0; i < this.vehicleSelectArr.length; i++) {
				        let testCar = this.contaArray.findIndex(n=>n.vehicleId==this.vehicleSelectArr[i])
				        if(this.contaArray[testCar].isTestCar == 1){
				      	  this.openModalMsg("选中车辆中有测试车，请选择正式车辆");
				      	  return;
				        }
				    }
					this.$refs.modalAdmin.open();
					classlist.toggleScroll('close','#carfile-list',this);
					
				}else{
					for(var i = 0; i < this.vehicleSelectArr.length; i++) {
				        let normalCar = this.contaArray.findIndex(n=>n.vehicleId==this.vehicleSelectArr[i])
				        if(this.contaArray[normalCar].isTestCar == 0){
				      	  this.openModalMsg("选中车辆中有正式车，请选择测试车辆");
				      	  return;
				        }
				    }
					this.messageStr = '确定将所选测试车变为正式车?'
					this.openModal("modalformalCar");
				}
				
			},
			//测试车与正式车互换
			confirformalCar(){
				this.closeModal('modalformalCar');
				if(this.normalTest ==1){
					const para = {
						reason: this.remarks, 
						vehicleIds: this.vehicleSelectArr,
					}
					this.loadingstatus = true;
				    this.$http.post(process.env.API_ROOT + '/vehicle/vehicles/downgrade/test', para)
				    .then( res => {
						if(res.body.success){
							this.vehicleSelectArr = [];
							this.contaArray = [];
							this.getTableInfo();
							this.openModalMsg("正式车成功降级为测试车");
						}else {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
						}
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					})
				}else{
					this.loadingstatus = true;
				    this.$http.post(process.env.API_ROOT + '/vehicle/vehicles/upgrade/formal', this.vehicleSelectArr)
				    .then( res => {
						if(res.body.success){
							this.vehicleSelectArr = [];
							this.contaArray = [];
							this.getTableInfo();
							this.openModalMsg("测试车成功升级为正式车");
						}else {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
						}
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					})
				}
			},
			//删除所选车辆
			removeItem() {
				this.loadingstatus = true;
				this.closeModal('modal2');
				this.$http.delete(process.env.API_ROOT + "/migration/vehicle/test",{body:this.vehicleSelectArr})
				.then( res => {
					if(res.data.success){
						this.getTableInfo();
						this.vehicleSelectArr =[];
						this.openModalMsg(OPERATE_SUCCESS);
					} else {
						this.openModalMsg(res.data.message);
						this.loadingstatus = false;
					}
					
				}, res => {
					this.openModalMsg(res.data.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.openModalMsg(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				});
			},
			removeVehicle(){
				if(this.vehicleSelectArr.length==0){
					this.openModalMsg("请选择要删除的车辆");
					return;
				}
				this.openModal("modal2");
			}
		}
	};
</script>
<style scoped>
	.menuInput{
		position:relative;
	}
	.menuContent{
		position:absolute;
		top:31px;
		left:6px;
		border:1px solid #ddd;
		z-index:999;
		
	}
	
</style>


// WEBPACK FOOTER //
// PageFileCarList.vue?38b6a755